import {mapActions, mapGetters} from "vuex";
import { getStudentsTranslation } from "@/helpers/students-translations";

export default {
    name: 'course-sidebar-top-students',

    created() {
        if (this.currentCourse) {
            this.fetchList({id: this.currentCourse.id, limit: 3})
        }
    },
    computed: {
        ...mapGetters({
            listStudents: 'coursesWidgets/listStudents',
            currentCourse: 'courses/currentItem',
            // Use specific loading state for top students
            isListStudentsLoading: 'coursesWidgets/isTopStudentsLoading'
        }),
    },

    methods: {
        ...mapActions({
            fetchList: 'coursesWidgets/FETCH_STUDENTS_LIST'
        }),
        imgAvatar(item) {
            if (item && item.avatar && item.avatar !== '') {
                return item.avatar;
            }
            return require('@/assets/img/default-avatar.jpg');
        },
        formatPoints(points) {
            if (points == null || points === undefined) return '0';
            return new Intl.NumberFormat().format(Number(points));
        },
        getPositionChangeLabel(change) {
            if (change > 0) {
                return this.getTranslation('positionUp', { change });
            } else if (change < 0) {
                return this.getTranslation('positionDown', { change: Math.abs(change) });
            }
            return '';
        },
        getTranslation(key, params = {}) {
            // Get current locale from multiple sources
            const currentLocale = this.$i18n?.locale || 'en';
            const urlLocale = window.location.pathname.split('/')[1];
            const isUkrainian = currentLocale === 'uk' || currentLocale === 'ua' || currentLocale.startsWith('uk') || 
                               urlLocale === 'uk' || urlLocale === 'ua' || urlLocale.startsWith('uk');
            const locale = isUkrainian ? 'uk' : 'en';
            
            console.log('Translation detection:', {
                key,
                currentLocale,
                urlLocale,
                isUkrainian,
                locale,
                pathname: window.location.pathname
            });
            
            // For Ukrainian locale, prioritize local translations
            if (isUkrainian) {
                const localTranslation = getStudentsTranslation(key, locale, params);
                console.log('Ukrainian translation result:', {
                    key,
                    localTranslation
                });
                return localTranslation;
            }
            
            // For English, try server translation first
            try {
                const serverTranslation = this.$t(key, params);
                if (serverTranslation && serverTranslation !== key && serverTranslation !== `[${key}]`) {
                    return serverTranslation;
                }
            } catch (error) {
                console.warn('Server translation failed for key:', key, error);
            }
            
            // Fallback to local translation
            const localTranslation = getStudentsTranslation(key, locale, params);
            
            console.log('English translation result:', {
                key,
                currentLocale,
                isUkrainian,
                locale,
                serverTranslation: this.$t(key, params),
                localTranslation,
                finalResult: localTranslation
            });
            
            return localTranslation;
        }
    }
}
